import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { CalendarEventPage } from '@features/calendar/components/CalendarEventPage'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/calendar/events/$eventId')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Event details',
        }
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load event'>
            <Suspense fallback={<LoadingIndicator resource='event details'/>}>
                <CalendarEventPage />
            </Suspense>
        </QueryErrorBoundary>
    )
}